module.exports = __webpack_public_path__ + "img/sichuan.c9b9cc28.png";